export default __webpack_public_path__ + "static/media/big-car-go-brummm.276e0027.png";